import { createAction, props } from "@ngrx/store";

export const setCity = createAction('[City] Set City Id',props<{cityId:string}>())